import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../globals';
import { User } from '../modal/user';
import { LoginData } from '../modal/login';


@Injectable({
    providedIn: 'root'
})

export class UserService {

    constructor(private httpclient: HttpClient, private global: Globals) { }
    registerUser(user){
        return this.httpclient.post<LoginData>(this.global.G_apiUrl + "/userRegistration",user);
    }
    
}